import React, { createContext, useState } from 'react';

export const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [showAlert, setShowAlert] = useState(false);

  const showAlertMessage = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const value = {
    showAlert,
    showAlertMessage,
  };

  return <AlertContext.Provider value={value}>{children}</AlertContext.Provider>;
};
